import { useRef, useState } from "react"
import { PRODUCT_TOUR_STEPS } from "../../product-tour/constants/steps"
import ActivitiesBoard from "./activities"
import StudyMetrics from "./header/metrics"
import StudyHeader from "./header/study-header"
import { VideoMiniModal } from "@/modules/product-tour-v2/components/video-mini-modal"
import useControlProductTour from "@/modules/product-tour-v2/hooks/use-controls"

export default function Study() {
  const scrollWeeklyRef = useRef<HTMLDivElement>(null)
  const [selectedTab, setSelectedTab] = useState("weekly")
  const [isHeaderSticky, setIsHeaderSticky] = useState(false)
  const { showVideo } = useControlProductTour()

  const handleOnChangeTab = (value: string) => {
    setSelectedTab(value)
  }

  return (
    <section
      className="grid h-full w-full grid-rows-[max-content,1fr] gap-4"
      id={PRODUCT_TOUR_STEPS.STUDY_MOVE_ACTIVITY}
    >
      <StudyMetrics />

      <div className="grid grid-cols-1 gap-4 px-6">
        <StudyHeader
          selectedTab={selectedTab}
          handleOnChangeTab={handleOnChangeTab}
          scrollWeeklyRef={scrollWeeklyRef}
          onStickyChange={setIsHeaderSticky}
        />
      </div>
      <div
        className="grid h-full grid-cols-1 gap-4 pb-6 pl-6"
        id={PRODUCT_TOUR_STEPS.STUDY_DO_ACTIVITY}
      >
        <ActivitiesBoard
          selectedTab={selectedTab}
          handleOnChangeTab={handleOnChangeTab}
          scrollWeeklyRef={scrollWeeklyRef}
          isSticky={isHeaderSticky}
        />
      </div>
      {showVideo && <VideoMiniModal />}
    </section>
  )
}
